import { createRouter, RouteRecordRaw, createWebHistory } from 'vue-router';
import Layout from '@/view/LayoutNew';

export const routesMenusNew: RouteRecordRaw = {
  path: '/',
  name: 'index',
  redirect: '/home',
  component: Layout,
  children: [
    {
      path: '/home',
      name: 'Homepage',
      meta: {
        pid: '1',
        title: 'Home',
      },
      component: () => import('@/view/Home/HomePage/index.vue'),
    },
    {
      path: '/search',
      name: 'Search',
      meta: {
        pid: '94',
        hide: true,
        title: 'Search',
      },
      component: () => import('@/view/Home/Search/index.vue'),
    },
    {
      path: '/strategy',
      name: 'Strategy',
      meta: {
        pid: '126',
        title: 'Data AI Strategy',
      },
      component: () => import('@/view/Extra/DataAIStrategy/index.vue'),
      children: [
        {
          path: 'data',
          name: 'Data Transformation',
          meta: {
            pid: '7',
            title: 'Data Transformation',
          },
          component: () => import('@/view/Extra/DataTransformation'),
        },
        {
          path: 'AI',
          name: 'AI Transformation',
          meta: {
            pid: '6',
            title: 'AI Transformation',
          },
          component: () => import('@/view/Extra/AIIntroduction/index.vue'),
        },
      ],
    },
    {
      path: '/services',
      name: 'Services',
      meta: {
        pid: '17',
        title: 'Services',
      },
      component: () => import('@/view/Services/index.vue'),
      children: [
        {
          path: 'ChinaGAIA',
          name: 'ChinaGAIA',
          meta: { title: 'China GAIA' },
          component: () => import('@/view/Extra/ProductService/GAIA/index.vue'),
        },
      ],
    },
    {
      path: '/usecase',
      name: 'Data & AI Use Case',
      meta: {
        pid: '18',
        title: 'Data & AI Use Case',
      },
      component: () => import('@/view/DataAIUseCase/index.vue'),
      children: [
        {
          path: 'showroom',
          name: 'Use Case Showroom',
          meta: {
            pid: '92',
            title: 'Use Case Showroom',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/index.vue'),
        },
        {
          path: 'AIOnePortal',
          name: 'AI One Portal',
          meta: {
            hide: true,
            pid: '165',
            title: 'AI One Portal',
          },
          component: () => import('@/view/Services/AIOnePortal/index.vue'),
        },
      ],
    },
    {
      path: '/trainingcenter',
      name: 'Training Center',
      meta: {
        pid: '19',
        title: 'Training Center',
      },
      component: () => import('@/view/TrainingCenter/index.vue'),
      children: [
        {
          path: 'library',
          name: 'knowledge',
          meta: {
            title: 'DTO Training Library',
            pid: '20',
            isNew: true,
          },
          component: () => import('@/view/TrainingCenter/Knowledge/index.vue'),
        },
        {
          path: 'video-clips/detail',
          name: 'videoClipDetail',
          meta: {
            hide: true,
            title: 'Video Clip Detail',
          },
          component: () => import('@/view/TrainingCenter/VideoClips/Detail/index.vue'),
        },
        {
          path: 'learningPath',
          name: 'learningPath',
          meta: {
            title: 'Learning Path',
            isNew: true,
          },
          component: () => import('@/view/TrainingCenter/LearningPath/index.vue'),
        },
        {
          path: 'pioneerProgram',
          name: 'pioneerProgram',
          meta: {
            title: 'Pioneer Program',
          },
          redirect: {
            name: 'AIPioneer',
          },
        },
        {
          path: 'dataPioneer',
          name: 'dataPioneer',
          meta: {
            title: 'Pioneer Program',
            pid: '136',
            hide: true,
            activeMenu: 'pioneerProgram',
          },
          component: () => import('@/view/TrainingCenter/DataAIPioneer/index.vue'),
        },
        {
          path: 'AIPioneer',
          name: 'AIPioneer',
          meta: {
            title: 'Pioneer Program',
            pid: '150',
            hide: true,
            activeMenu: 'pioneerProgram',
          },
          component: () => import('@/view/TrainingCenter/DataAIPioneer/index.vue'),
        },
        {
          path: 'digitalLiteracy',
          name: 'digitalLiteracy',
          meta: {
            title: 'Digital Literacy',
          },
          component: () => import('@/view/TrainingCenter/DigitalLiteracy/index.vue'),
        },
      ],
    },
    {
      path: '/connect',
      name: 'Connect',
      meta: {
        pid: '21',
        title: 'Connect',
      },
      component: () => import('@/view/Communitys'),
      children: [
        {
          path: 'DScommunity',
          name: 'dataSteward',
          meta: {
            title: 'Data Steward Community',
            pid: '22',
          },
          component: () => import('@/view/Communitys/DataAICommunity/DataSteward'),
          children: [
            {
              path: 'profile',
              name: 'dataStewardList',
              meta: {
                title: 'Data Steward Profile',
                pid: '23',
              },
              component: () =>
                import('@/view/Communitys/DataAICommunity/DataSteward/DataStewardList'),
            },
          ],
        },
        {
          path: 'DEcommunity',
          name: 'dataEngineer',
          meta: {
            title: 'Data Engineer Community',
            pid: '24',
          },
          component: () => import('@/view/Communitys/DataAICommunity/DataEngineer'),
          children: [
            {
              path: 'profile',
              name: 'dataEngineerList',
              meta: {
                title: 'Data Engineer Profile',
                pid: '25',
              },
              component: () =>
                import('@/view/Communitys/DataAICommunity/DataEngineer/DataEngineerList'),
            },
          ],
        },
        {
          path: 'AIcommunity',
          name: 'AICommunity',
          meta: {
            title: 'AI Community',
            pid: '26',
          },
          component: () => import('@/view/Communitys/DataAICommunity/AICommunity/index.vue'),
        },
        {
          path: 'events',
          name: 'Events',
          meta: {
            title: 'Events',
            pid: '27',
          },
          component: () => import('@/view/Communitys/Events'),
          children: [
            {
              path: 'AIOpenDay',
              name: 'AI Open Day',
              meta: {
                hide: true,
                pid: '135',
                title: 'AI Open Day',
              },
              component: () => import('@/view/Communitys/AiOpenDay/index.vue'),
            },
            {
              path: 'detail/:id?',
              name: 'Event Detail',
              meta: {
                hide: true,
                title: 'Event Detail',
              },
              component: () => import('@/view/Communitys/Events/EventDetail/index.vue'),
            },
            {
              path: 'Championship',
              name: 'D&A Use Case Championship',
              meta: {
                pid: '132',
                title: 'Data & AI Use Case Championship',
                hide: true,
              },
              component: () => import('@/view/DataAIUseCase/UseCaseChampionship'),
            },
          ],
        },
        {
          path: 'news',
          alias: '/extra/news',
          name: "What's New",
          meta: {
            pid: '13',
            title: 'News',
          },
          component: () => import('@/view/Extra/Newsletter'),
        },
      ],
    },
    {
      path: '/extra',
      name: 'extra',
      meta: {
        hide: true,
        title: 'Extra',
      },
      component: () => import('@/view/Extra/index.vue'),
      children: [
        {
          path: 'AI',
          name: 'AI',
          meta: {
            pid: '6',
            title: 'AI Transformation',
          },
          component: () => import('@/view/Extra/AIIntroduction/index.vue'),
        },
        {
          path: 'strategy',
          name: 'dataAIStrategy',
          meta: {
            pid: '126',
            title: 'Data AI Strategy',
          },
          component: () => import('@/view/Extra/DataAIStrategy/index.vue'),
        },
        {
          path: 'data',
          name: 'data',
          meta: {
            pid: '7',
            title: 'Data Transformation',
          },
          component: () => import('@/view/Extra/DataTransformation'),
        },
        {
          path: 'openday2024',
          name: 'openday2024',
          meta: { title: 'openday2024', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Openday/2023.vue'),
        },
        {
          path: 'openday2023',
          name: 'openday2023',
          meta: { title: 'openday2023', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Openday/2023.vue'),
        },
        {
          path: 'openday2022',
          name: 'openday2022',
          meta: { title: 'openday2022', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Openday/2022.vue'),
        },
        {
          path: 'openday2021',
          name: 'openday2021',
          meta: { title: 'openday2021', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Openday/2021.vue'),
        },
        {
          path: 'championship2021',
          name: 'championship2021',
          meta: { title: 'championship2021', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Championship/2021.vue'),
        },
        {
          path: 'championship2022',
          name: 'championship2022',
          meta: { title: 'championship2022', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Championship/2022.vue'),
        },
        {
          path: 'championship2023',
          name: 'championship2023',
          meta: { title: 'championship2023', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Championship/2023.vue'),
        },
        {
          path: 'overseasLaunch',
          name: 'overseasLaunch',
          meta: {
            hide: true,
            title: 'overseasLaunch',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/OverseasLaunch/index.vue'),
        },
        {
          path: 'AIPowered',
          name: 'AIPowered',
          meta: {
            hide: true,
            pid: '45',
            title: 'AI Powered',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/AIPowered/index.vue'),
        },
        {
          path: 'tracingDashboard',
          name: 'TracingDashboard',
          meta: {
            hide: true,
            title: 'Tracing Dashboard',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/TracingDashboard/index.vue'),
        },
        {
          path: 'prewarning',
          name: 'Prewarning',
          meta: {
            hide: true,
            title: 'Prewarning',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/Prewarning/index.vue'),
        },
        {
          path: 'customerInteraction',
          name: 'CustomerInteraction',
          meta: {
            hide: true,
            title: 'Customer Interaction',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/CustomerInteraction/index.vue'),
        },
        {
          path: 'heatmap',
          name: 'Heatmap',
          meta: {
            hide: true,
            title: 'Heatmap',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/Heatmap/index.vue'),
        },
        {
          path: 'dataMerging',
          name: 'DataMerging',
          meta: {
            hide: true,
            pid: '01',
            title: 'Data Merging',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/DataMerging/index.vue'),
        },
        {
          path: 'KpiImprovements',
          name: 'KpiImprovements',
          meta: {
            hide: true,
            title: 'Kpi Improvements',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/KpiImprovements/index.vue'),
        },
        {
          path: 'AIKnowledge',
          name: 'AIKnowledge',
          meta: {
            hide: true,
            title: 'AI Knowledge',
          },
          component: () => import('@/view/DataAIUseCase/Showroom/AIKnowledge/index.vue'),
        },
        {
          path: 'No1',
          name: 'No1',
          meta: { title: 'No1', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No1.vue'),
        },
        {
          path: 'No2',
          name: 'No2',
          meta: { title: 'No2', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No2.vue'),
        },
        {
          path: 'No3',
          name: 'No3',
          meta: { title: 'No3', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No3.vue'),
        },
        {
          path: 'No4',
          name: 'No4',
          meta: { title: 'No4', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No4.vue'),
        },
        {
          path: 'No5',
          name: 'No5',
          meta: { title: 'No5', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No5.vue'),
        },
        {
          path: 'No6',
          name: 'No6',
          meta: { title: 'No6', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No6.vue'),
        },
        {
          path: 'No7',
          name: 'No7',
          meta: { title: 'No7', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No7.vue'),
        },
        {
          path: 'No8',
          name: 'No8',
          meta: { title: 'No8', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No8.vue'),
        },
        {
          path: 'No9',
          name: 'No9',
          meta: { title: 'No9', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No9.vue'),
        },
        {
          path: 'No10',
          name: 'No10',
          meta: { title: 'No10', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No10.vue'),
        },
        {
          path: 'No11',
          name: 'No11',
          meta: { title: 'No11', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No11.vue'),
        },
        {
          path: 'No12',
          name: 'No12',
          meta: { title: 'No12', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/No12.vue'),
        },
        {
          path: 'dataPioneerProgram',
          name: 'dataPioneerProgram',
          meta: { title: 'Data Pioneer Program', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/NewDataExtra/dataPioneerProgram'),
        },
        {
          path: 'dataStewardCommunity',
          name: 'dataStewardCommunity',
          meta: { title: 'Data Steward Community', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/NewDataExtra/dataStewardCommunity'),
        },
        {
          path: 'aiCoeSharing',
          name: 'aiCoeSharing',
          meta: { title: 'Ai Coe Sharing', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/NewDataExtra/aiCoeSharing'),
        },
        {
          path: 'dataOpsRollout2024',
          name: 'dataOpsRollout2024',
          meta: { title: 'Data Ops Rollout 2024', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/NewDataExtra/dataOpsRollout2024'),
        },
        {
          path: 'productServiceEDM',
          name: 'productServiceEDM',
          meta: { title: 'Product Service EDM' },
          component: () => import('@/view/Extra/ProductService/EDM'),
        },
        {
          path: 'productServiceBP',
          name: 'productServiceBP',
          meta: { title: 'Product Service BP' },
          component: () => import('@/view/Extra/ProductService/BeaconPlatform'),
        },
        {
          path: 'productServiceDA',
          name: 'productServiceDA',
          meta: { title: 'Product Service DA' },
          component: () => import('@/view/Extra/ProductService/DigitalAssistant'),
        },
        {
          path: 'productServiceGenova',
          name: 'productServiceGenova',
          meta: { title: 'Product Service Genova' },
          component: () => import('@/view/Extra/ProductService/Genova'),
        },
        {
          path: 'productServiceCDH',
          name: 'productServiceCDH',
          meta: { title: 'Product Service CDH' },
          component: () => import('@/view/Extra/ProductService/CDH'),
        },
        {
          path: 'productServicePowerBI',
          name: 'productServicePowerBI',
          meta: { title: 'Product Service PowerBI' },
          component: () => import('@/view/Extra/ProductService/PowerBI'),
        },
        {
          path: 'productServiceTableau',
          name: 'productServiceTableau',
          meta: { title: 'Product Service Tableau' },
          component: () => import('@/view/Extra/ProductService/Tableau'),
        },
        {
          path: 'productServiceDASSP',
          name: 'productServiceDASSP',
          meta: { title: 'Product Service DASSP' },
          component: () => import('@/view/Extra/ProductService/DASSP'),
        },
        {
          path: 'productServiceCelonis',
          name: 'productServiceCelonis',
          meta: { title: 'Product Service Celonis' },
          component: () => import('@/view/Extra/ProductService/Celonis/index.vue'),
        },
        {
          path: 'productJoyCode',
          name: 'productJoyCode',
          meta: { title: 'Product JoyCode' },
          component: () => import('@/view/Extra/ProductService/JoyCode/index.vue'),
        },
        {
          path: 'productJoyChat',
          name: 'productJoyChat',
          meta: { title: 'Product JoyChat' },
          component: () => import('@/view/Extra/ProductService/JoyChat/index.vue'),
        },
        {
          path: 'newsDetail',
          name: 'newsDetail',
          meta: { title: 'News Detail', activeMenu: "What's New" },
          component: () => import('@/view/Extra/Newsletter/NewsbyHt'),
        },
        {
          path: 'sendEmail',
          name: 'sendEmail',
          meta: { title: 'Send Email' },
          component: () => import('@/view/Extra/SendEmailPage'),
        },
        {
          path: 'useCaseDetail',
          name: 'useCaseDetail',
          meta: { title: 'UseCase Detail' },
          component: () => import('@/view/DataAIUseCase/Showroom/UseCaseDetail/index.vue'),
        },
        {
          path: 'aiSharingRecapDetail',
          name: 'aiSharingRecapDetail',
          meta: { title: 'AI Sharing Recap Detail' },
          component: () =>
            import('@/view/Communitys/DataAICommunity/AISharingRecapDetail/index.vue'),
        },
        {
          path: 'productServiceDetail',
          name: 'productServiceDetail',
          meta: { title: 'Product Service Detail' },
          component: () => import('@/view/Extra/ProductService/Detail/index.vue'),
        },
        {
          path: 'productServiceCopilot',
          name: 'ProductServiceCopilot',
          meta: { title: 'Copilot', isNew: true },
          component: () => import('@/view/Extra/ProductService/Copilot/index.vue'),
        },
      ],
    },
  ],
};

export const routes: RouteRecordRaw[] = [
  {
    ...routesMenusNew,
  },
  {
    path: '/edmWebpage',
    name: 'edmWebpage',
    component: () => import('@/view/DataAIUseCase/EDMWebpage'),
    alias: '/usecasePortfolio',
    meta: {
      title: 'EDM Webpage',
    },
  },
  {
    path: '/sso',
    name: 'sso',
    component: () => import('@/view/Login/Sso.vue'),
    meta: {
      title: 'Sso',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/view/Login/index.vue'),
    meta: {
      title: 'Login',
    },
  },
  {
    path: '/:pathMatch(.*)',
    redirect: (to) => ({
      name: 'login',
      query: {
        redirect: to.fullPath,
      },
    }),
  },
  {
    path: '/applyToJoinAICommunity',
    name: 'ApplyToJoinAICommunity',
    meta: {
      title: 'Apply to Join AI Community',
    },
    component: () => import('@/view/ApplyToJoinAICommunity/index.vue'),
  },
];

export interface routeMappingType {
  name: string;
  path: string;
}

export const formatRouterMapping = (routes: RouteRecordRaw[]) => {
  const routerMapping: Record<string, routeMappingType[]> = {};
  const dfs = (routes: RouteRecordRaw[]) => {
    routes.forEach((route) => {
      if (route.children) {
        dfs(route.children);
      }

      if (route.children) {
        if (route?.meta?.pid) {
          route.children.forEach((item) => {
            item?.meta?.pid &&
              routerMapping[String(item.meta.pid)]?.unshift({
                path: route.path,
                name: String(route.name),
              });
          });
        }
      } else if (route?.meta?.pid) {
        routerMapping[String(route.meta.pid)] = [{ path: route.path, name: String(route.name) }];
      }
    });
  };

  dfs(routes);

  return routerMapping;
};

export default createRouter({
  history: createWebHistory(),
  routes,
});
